<template>
  <div>
    <div class="tabs is-separatedUnderlined is-fullwidth is-marginless">
      <ul class="has-text-weight-medium">
        <li :class="{'is-active':panel === 'INFOS'}"><a @click="panel = 'INFOS'">Informations utilisateur</a></li>
        <li v-if="!isNew && isAdmin && showSellerSettings" :class="{'is-active':panel === 'DOCS'}"><a @click="panel = 'DOCS'">Documents</a></li>
      </ul>
    </div>
    <div class="has-bg-brand is-padding-left is-padding-right is-margin-top-xsmall">
      <div class="has-text-white is-size-6 is-padding-top-xsmall is-padding-bottom-xsmall">
        <span class="icon is-small is-size-7"><i class="fas fa-check-circle"></i></span>
        <i>Information obligatoire pour la validation du formulaire</i>
      </div>
    </div>
    <form @submit.prevent.stop="submit()" id="form-user">
      <div v-show="panel === 'INFOS'">
        <div class="columns is-multiline is-border-top">
          <div class="column is-12 is-padding-bottom-xsmall">
            <r-label :label="'Civilité'" :value="u.title"></r-label>
          </div>
          <div class="column is-gapless is-paddingless is-12 columns is-multiline">
            <div class="column is-12 is-padding-left-small is-padding-right-small columns is-variable is-2 is-multiline">
              <div class="column is-3 is-2-widescreen is-paddingless-bottom is-paddingless-top">
                <input class="checkradiocase is-primary is-fullwidth" v-validate="'required'" id="M" type="radio" name="title"
                      value="mr"
                      v-model="u.title">
                <label for="M">M.</label>
              </div>
              <div class="column is-3 is-2-widescreen is-paddingless-bottom is-paddingless-top">
                <input class="checkradiocase is-primary is-fullwidth" id="Mme" type="radio" name="title" value="mrs" v-model="u.title">
                <label for="Mme">Mme</label>
              </div>
              <p v-if="errors.has('title')" class="help is-danger column is-3 is-paddingless">La civilité est obligatoire.</p>
            </div>
            <div class="column is-6 is-padding-left is-padding-right is-padding-top">
              <r-label :label="'Nom'" :value="u.last_name"></r-label>
              <v-input id="last_name" name="last_name" @input="val => u.last_name = val" :model="u.last_name"
                      data-vv-as="Nom"
                      v-validate="'required|min:2'" :errors-bag="errors" data-vv-value-path="val">
              </v-input>
            </div>
            <div class="column is-6 is-padding-left is-padding-right is-padding-top">
              <r-label :label="'Prénom'" :value="u.first_name"></r-label>
              <v-input id="first_name" name="first_name" @input="val => u.first_name = val" :model="u.first_name"
                      v-validate="'required|min:2'" :errors-bag="errors" data-vv-value-path="val"
                      data-vv-as="Prénom">
              </v-input>
            </div>
            <div class="column is-6 is-3-widescreen is-padding-left is-padding-right is-padding-top">
              <r-label :label="'Adresse mail'" :value="u.email"></r-label>
              <v-input id="email" name="email" @input="updateMail" :model="u.email" class=""
                      v-validate="'required|email'" :errors-bag="errors" data-vv-value-path="val"
                      data-vv-as="Email">
              </v-input>
              <p class="help is-danger" v-if="!emailAvailable">L'email existe déjà.</p>
            </div>
            <div class="column is-6 is-3-widescreen is-padding-left is-padding-right is-padding-top">
              <label class="label is-margin-bottom-large">Notifications mail</label>
              <input id="mail_alert" type="checkbox" name="mail_alert" v-model="u.mail_alert"
                      class="switch is-success is-rounded is-medium">
              <label for="mail_alert">{{u.mail_alert ? 'Oui' : 'Non'}}</label>
            </div>
            <div class="column is-6 is-3-widescreen is-padding-left is-padding-right is-padding-top">
              <r-label :label="'Téléphone (fixe ou mobile)'" :value="u.phone"></r-label>
              <the-mask :mask="$configs.COUNTRY === 'FRA' ? '## ## ## ## ##' : '####################'"
                        v-model="u.phone" @input="val => u.phone = val"
                        id="buyerPhone" name="buyerPhone" class="input" />
            </div>
            <div class="column is-6 is-3-widescreen is-padding-left is-padding-right is-padding-top">
              <label class="label is-margin-bottom-large">Notifications sms</label>
              <input id="sms_alert" type="checkbox" name="sms_alert" v-model="u.sms_alert"
                    class="switch is-success is-rounded is-medium">
              <label for="sms_alert">{{u.sms_alert ? 'Oui' : 'Non'}}</label>
            </div>
            <div class="column is-12 is-padding-top">
              <div class="field">
                <div class="control">
                  <gmap-input :source="address" @submit="updateAddress"></gmap-input>
                </div>
              </div>
            </div>
            <div class="column is-12 is-paddingless">
              <div class="columns">
                <div class="column">
                  <div class="field">
                    <label class="label is-padding-bottom-xsmall">Photo de profil
                      <span class="is-size-3 is-margin-left-xsmall"
                            v-helper.right="'4B6D9fET04y6UgQsEkAqoM'">
                        <i class="fal fa-question-circle fa-xs has-text-grey"></i>
                      </span>
                    </label>
                  </div>
                  <div class="control">
                    <upload-file @upload="uploadPictures" :documents="pictures" :multiple="false"
                                custom-id="avatar" :canDrag='false'
                                :privacy="false" :unique="true"
                                @deleteDocuments="deleteFile('pictures', 'picture')"
                                :is-image="true" :ratio="1">
                    </upload-file>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="columns is-multiline has-bg-light is-padding-bottom" v-if="isAdmin || (isSectorManager && currentUser.pk !== u.pk)">
          <div class="column is-12 is-paddingless-bottom">
            <div class="title is-5">
              <b class="is-uppercase">Profil de l'utilisateur</b>
            </div>
          </div>
          <div class="column is-gapless is-paddingless is-12 columns is-multiline">
            <div class="column is-half is-padding-left is-padding-right is-padding-top">
              <div class="field columns is-column is-space-between is-height-full">
                <r-label :label="'Rôle / Fonction'" :value="u.profil"></r-label>
                <div class="select is-fullwidth">
                  <select name="profil" data-vv-as="Profil" v-validate="'required|included:'+profilPkList.join(',')"
                          v-model="u.profil" :class="{'is-danger': errors.has('profil')}"
                          @change="updateHelperText(); updateProfilType()">
                    <option :value="null">Selectionnez le profil</option>
                    <option v-for="p in availableProfils" :value="p.pk" :key="p.pk">{{p.name}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="column is-half is-padding-left is-padding-right is-padding-top">
              <!--<label class="label">&nbsp;</label>-->
              <div v-if="u.profil && profilHelperText"
                  class="notification is-warning is-padding-top-small is-padding-bottom-small is-height-full is-vcentered is-size-6"
                  v-html="profilHelperText">
              </div>
            </div>
            <div class="column is-6 is-padding-left is-padding-right is-padding-top"
                  v-if="(isAdmin || isManager || isSectorManager) && currentUserProfil !== 'manager_ext' && userIsExternal">
              <r-label :label="'Société'" :value="u.company">
                <span class="is-size-3"><i class="fas fa-fake-for-align-label fa-xs"></i></span>
              </r-label>
              <div class="field">
                <div class="control">
                  <multiselect v-model="u.company" label="name" track-by="pk" :placeholder="''"
                              :options="companies" :searchable="true" :close-on-select="true" :show-labels="false"
                              class="multiselect--option-ico"
                              @search-change="getCompanies">
                    <template slot="clear" slot-scope="props">
                      <div class="multiselect__clear" v-if="companies.length"
                          @mousedown.prevent.stop="clearAll(props.search)"></div>
                    </template>
                    <span slot="noResult">Oups! Aucune société trouvée.</span>
                    <span slot="noOptions">La liste est vide</span>
                    <span slot="placeholder" class="multiselect__placeholder">Sélectionnez ou saisissez une société</span>
                  </multiselect>
                  <p class="help is-danger" v-if="!u.company">Veuillez sélectionner une société</p>
                </div>
              </div>
            </div>
            <div class="column is-6 is-padding-left is-padding-right is-padding-top" v-if="(isAdmin || isManager || isSectorManager) && showManagerForm">
              <label class="label" for="first_name">Manager<span class="is-size-3"><i class="fas fa-fake-for-align-label fa-xs"></i></span></label>
              <div class="field">
                <div class="control">
                  <multiselect v-model="manager" label="name" track-by="pk" :placeholder="''"
                              :options="managers" :searchable="true" :close-on-select="true" :show-labels="false"
                              @search-change="getManagers"
                              class="multiselect--option-ico"
                              :disabled="['manager_ext', 'seller_ext'].includes(u.profil_type) && (!u.company || !managers || !managers.length)"
                              :custom-label="sellerName">
                    <template slot="clear" slot-scope="props">
                      <div class="multiselect__clear" v-if="managers.length"
                          @mousedown.prevent.stop="clearAll(props.search)"></div>
                    </template>
                    <span slot="noResult">Oups! Aucun manager trouvé.</span>
                    <span slot="noOptions">La liste est vide</span>
                    <span slot="placeholder" class="multiselect__placeholder">Sélectionnez ou saisissez un manager</span>
                  </multiselect>
                </div>
                <div v-if="['manager_ext', 'seller_ext'].includes(u.profil_type) && !u.company" class="help is-info">Veuillez sélectionner une société pour voir sa liste de managers</div>
                <div v-if="u.company && (!managers || !managers.length)" class="help is-info">Pas de manager dans cette société</div>
              </div>
            </div>
            <div class="column is-6 is-padding-left is-padding-right is-padding-top" v-if="isAdmin && !u.is_admin && u.profil && !noReferentStatus.includes(u.profil_type)">
              <div class="field">
                <label class="label" for="referent-user">
                  Admin Référent <span v-if="u.referent_name">: {{u.referent_name}}</span>
                  <span class="is-size-3 is-margin-left-xsmall"
                        v-helper.right.medium="'42lfeNvsw8Npw3UL3MS5iq'">
                    <i class="fas fa-question-circle fa-xs has-text-grey"></i>
                  </span>
                </label>
                <div class="control">
                  <multiselect id="referent-user" name="referent-user" v-model="referent" :options="admins" :multiple="false" :searchable="true"
                              :close-on-select="true" :show-labels="false" :placeholder="''"
                              class="multiselect--option-ico"
                              :custom-label="sellerName" track-by="pk" @search-change="getAdmins">
                    <span slot="placeholder" class="multiselect__placeholder">Sélectionnez un administrateur</span>
                    <span slot="noOptions">La liste est vide</span>
                  </multiselect>
                </div>
              </div>
            </div>
            <div class="column is-12 is-paddingless-bottom is-padding-left is-padding-right is-padding-top"
                  v-if="displaySwitchDisplayMyRem || displaySwitchCanDisplayRem">
              <div class="title is-5">
                <b class="is-uppercase">Rémunération</b>
              </div>
            </div>
            <div class="column is-3 is-padding-left is-padding-right is-padding-top" v-if="(isAdmin || isSectorManager) && showSellerSettings && !u.is_external">
              <div class="field">
                <label class="label" for="first_name">Rémunération en %</label>
                <div class="columns is-gapless">
                  <p class="control column">
                    <input name="remuneration" v-model.number="u.remuneration"
                          class="input" step=".01" max="100" type="number"
                          data-type-cy="input" data-value-cy="input_user_remuneration">
                  </p>
                  <p class="control column is-narrow has-bg-light is-border-top is-border-right is-border-bottom columns is-vcentered">
                    <span class="is-padding-left is-padding-right">%</span>
                  </p>
                </div>
              </div>
            </div>
            <div class="column is-6 is-padding-left is-padding-right is-padding-top" v-if="displaySwitchCanDisplayRem">
              <div class="field">
                <label class="label" for="first_name">L'utilisateur peut voir sa rémunération</label>
                <div class="control is-margin-top-small">
                  <input id="can_display_remuneration" type="checkbox" name="can_display_remuneration" v-model="u.can_display_remuneration"
                      class="switch is-success is-rounded is-medium">
                  <label for="can_display_remuneration">{{u.can_display_remuneration ? 'Oui' : 'Non'}}</label>
                </div>
              </div>
            </div>
            <div class="column is-6 is-padding-left is-padding-right is-padding-top" v-if="displaySwitchDisplayMyRem">
              <div class="field">
                <label class="label" for="first_name">Afficher {{isAdmin ? 'les' : 'ma'}} rémunération{{isAdmin ? 's' : ''}} par défaut</label>
                <div class="control">
                  <input id="display_remuneration" type="checkbox" name="display_remuneration" v-model="u.display_remuneration"
                      class="switch is-success is-rounded is-medium">
                  <label for="display_remuneration">{{u.display_remuneration ? 'Oui' : 'Non'}}</label>
                </div>
              </div>
            </div>
            <div class="column is-12 is-padding-left is-padding-right is-paddingless-bottom is-padding-top" v-if="(isAdmin || isSectorManager) && showSellerSettings">
              <div class="title is-5">
                <b class="is-uppercase">Paramètres</b>
              </div>
            </div>
            <div class="column is-3 is-padding-left is-padding-right is-padding-top" v-if="(isAdmin || isSectorManager) && showSellerSettings">
              <div class="field">
                <label class="label" for="first_name">Options max par contact</label>
                <div class="control">
                  <v-input id="max_options_by_client" name="max_options_by_client"
                          @input="val => u.max_options_by_client = val" :model="u.max_options_by_client"
                          :errors-bag="errors" data-vv-value-path="val"
                          v-validate="'decimal:0'"
                          data-vv-as="Options max par contact">
                  </v-input>
                </div>
              </div>
            </div>
            <div class="column is-3 is-padding-left is-padding-right is-padding-top" v-if="(isAdmin || isSectorManager) && showSellerSettings">
              <div class="field">
                <label class="label" for="first_name">Options max</label>
                <div class="control">
                  <v-input id="max_options" name="max_options" @input="val => u.max_options = val" :model="u.max_options"
                          :errors-bag="errors" data-vv-value-path="val" v-validate="'decimal:0'"
                          data-vv-as="Options max">
                  </v-input>
                </div>
              </div>
            </div>
            <div class="column is-12 is-padding-left is-padding-right is-paddingless-bottom is-padding-top" v-if="!isNew && showGoalsForm">
              <div class="title is-5">
                <b class="is-uppercase">Objectifs Annuels</b>
              </div>
            </div>
            <div class="column is-6 is-padding-left is-padding-right is-padding-top" v-if="!isNew && showGoalsForm">
              <div class="is-tab-like is-border-bottom column is-12 is-gapless is-paddingless">
                <a v-for="y in years" :key="y"
                  @click="setCurrentYear(y)"
                  :class="{'is-active': parseInt(y) === parseInt(currentYear)}"
                  class="button is-white is-transform-none is-padding-left-small is-padding-right-small is-min-width-0">
                  {{y}}
                </a>
              </div>
              <div class="column is-6 is-paddingless-left" v-if="currentYear && currentGoal">
                <label for="" class="label">Objectif</label>
                <div class="field has-addons">
                  <div class="control is-expanded">
                    <v-input :id="'goal-' + currentYear" name="'goal-' + currentYear" @input="val => currentGoal.goal = val"
                        :model="currentGoal.goal"
                        :number="true"
                        v-validate="'decimal:2'" :errors-bag="errors" data-vv-value-path="val"
                        data-vv-as="Objectif">
                    </v-input>
                  </div>
                  <div class="control">
                    <a class="button is-square is-static is-border is-min-width-0">
                      <span class="icon"><i :class="`fas fa-${$faCurrency}-sign`"></i></span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="columns is-multiline is-margin-top-small" v-if="isNew">
          <p class="column is-12 is-size-5 has-text-grey is-padding-bottom-xsmall">
            Souhaitez-vous inviter ce nouvel utilisateur à finaliser la création de son compte pour lui permettre
            d'effectuer sa première connexion ?
          </p>
          <div class="column">
            <input class="is-checkradio" id="invit" value="true" type="radio" name="invit"
                  v-model="invitUser">
            <label for="invit" class="label is-size-6 has-text-grey">Oui, lui envoyer une invitation</label>
            <br><br>
            <input class="is-checkradio" id="notInvit" value="false" type="radio" name="notInvit"
                  v-model="invitUser">
            <label for="notInvit" class="label is-size-6 has-text-grey">Non, lui envoyer une invitation plus
              tard</label>
          </div>
        </div>
      </div>
      <div v-show="panel === 'DOCS'">
        <div class="columns is-multiline">
          <div class="column is-12 is-paddingless-bottom">
            <label class="label">Carte de Transaction</label>
            <upload-file @upload="uploadcarteTransactionFile" :documents="carteTransactionFile" :multiple="false"
                         :unique="true" :can-drag="false" custom-id="carteTransactionFile"
                         @deleteDocuments="deleteFile('carteTransactionFile', 'carte_de_transaction_validity_date')"
            ></upload-file>
          </div>
          <div class="column is-6">
            <label class="label" v-if="carteTransactionFile.length">Date de validité de la carte de transaction</label>
            <div class="field has-addons" v-if="carteTransactionFile.length">
              <div class="control">
                <a class="button is-square is-static is-border is-min-width-0">
                  <span class="icon"><i class="fas fa-calendar-alt"></i></span>
                </a>
              </div>
              <div class="control is-expanded has-icons-right">
                <flat-pickr :config="configDate" @on-open="startDateOpened = true" @on-close="startDateClosed = true"
                            v-model="carteTransactionValidityDate" class="input is-radiusless"
                            name="carteTransactionValidityDate"
                            :class="{'is-danger': errors.has('carteTransactionValidityDate')  && startDateOpened && startDateClosed}"
                            data-vv-as="Date de validité"></flat-pickr>
              </div>
              <div class="control">
                <a class="button is-square is-radiusless" @click="carteTransactionValidityDate = null">
                  <i class="fal fa-times"></i>
                </a>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <v-input v-if="carteTransactionFile.length" :id="'carte_de_transaction_num'"
                    :name="'carte_de_transaction_num'"
                    @input="val => u.carte_de_transaction_num = val" :model="u.carte_de_transaction_num"
                    label="Numero de la carte de transaction"
                    data-vv-as="Numero de la carte de transaction" :errors-bag="errors"
                    data-vv-value-path="val">
            </v-input>
          </div>
        </div>
        <div class="columns is-multiline is-border-top">
          <div class="column is-12 is-paddingless-bottom">
            <label class="label">Garantie Financière</label>
            <upload-file @upload="uploadgarantieFinanciereFile" :documents="garantieFinanciereFile" :multiple="false"
                        :unique="true" :can-drag="false" custom-id="garantieFinanciereFile"
                        @deleteDocuments="deleteFile('garantieFinanciereFile', 'garantie_financiere_validity_date')"></upload-file>
          </div>
          <div class="column is-6">
            <label class="label" v-if="garantieFinanciereFile.length">Date de validité de la garantie financière</label>
            <div class="field has-addons" v-if="garantieFinanciereFile.length">
              <div class="control">
                <a class="button is-square is-static is-border is-min-width-0">
                  <span class="icon"><i class="fas fa-calendar-alt"></i></span>
                </a>
              </div>
              <div class="control is-expanded has-icons-right">
                <flat-pickr :config="configDate" @on-open="startDateOpened = true" @on-close="startDateClosed = true"
                            v-model="garantieFinanciereValidityDate" class="input is-radiusless"
                            name="garantieFinanciereValidityDate"
                            :class="{'is-danger': errors.has('garantieFinanciereValidityDate')  && startDateOpened && startDateClosed}"
                            data-vv-as="Date de validité"></flat-pickr>
              </div>
              <div class="control">
                <a class="button is-square is-radiusless" @click="garantieFinanciereValidityDate = null">
                  <i class="fal fa-times"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="columns is-multiline is-border-top">
          <div class="column is-12">
            <label class="label">RC Professionnelle</label>
            <upload-file @upload="uploadrcProfessionnelleFile" :documents="rcProfessionnelleFile" :multiple="false"
                        :unique="true" :can-drag="false" custom-id="rcProfessionnelleFile"
                        @deleteDocuments="deleteFile('rcProfessionnelleFile', 'rc_professionnelle_validity_date')"></upload-file>
          </div>
          <div class="column is-6">
            <label class="label" v-if="rcProfessionnelleFile && rcProfessionnelleFile.length">Date validité RC
              Professionnelle</label>
            <div class="field has-addons" v-if="rcProfessionnelleFile && rcProfessionnelleFile.length">
              <div class="control">
                <a class="button is-square is-static is-border is-min-width-0">
                  <span class="icon"><i class="fas fa-calendar-alt"></i></span>
                </a>
              </div>
              <div class="control is-expanded has-icons-right">
                <flat-pickr :config="configDate" @on-open="startDateOpened = true" @on-close="startDateClosed = true"
                            v-model="rcProfessionnelleValidityDate" class="input is-radiusless"
                            name="rcProfessionnelleValidityDate"
                            :class="{'is-danger': errors.has('rcProfessionnelleValidityDate')  && startDateOpened && startDateClosed}"
                            data-vv-as="Date de validité">
                </flat-pickr>
              </div>
              <div class="control">
                <a class="button is-square is-radiusless" @click="rcProfessionnelleValidityDate = null">
                  <i class="fal fa-times"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formActionsSticky is-bottom">
        <div class=" columns is-gapless is-centered has-bg-white is-padding-top-small is-padding-bottom-small">
          <div class="column is-4 is-3-widescreen is-margin-right-small">
            <a @click="$router.goBack(route)" class="button is-light is-uppercase is-fullwidth">
              <span>Annuler</span>
            </a>
          </div>
          <div class="column is-4 is-3-widescreen is-margin-left-small">
            <button class="button is-success is-uppercase is-fullwidth has-text-white" type="submit"
                  :disabled="!canSubmit || loading" :class="{'is-loading':loading}">
              <span v-if="!loading">Valider</span>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import moment from 'moment'
  import { DefaultValues } from '@/mixins'
  import { mapState, mapGetters } from 'vuex'
  import { find, isEmpty, isNil, orderBy } from 'lodash'

  const showdown = require('showdown')

  const emptyUser = {
    address: {},
    company: null,
    email: null,
    first_name: null,
    last_name: null,
    manager: null,
    mobile: null,
    phone: null,
    profil: null,
    picture: {},
    max_options: 20,
    max_options_by_client: 3,
    sms_alert: true,
    mail_alert: true,
    canDisplayRemuneration: false
  }

  export default {
    name: 'UserForm',
    data () {
      return {
        noReferentStatus: ['admin', 'sector_manager'],
        user: {},
        profilHelperText: null,
        companies: [],
        pictures: [],
        completeAddress: false,
        emailAvailable: true,
        documents: [],
        carteTransactionFile: [],
        carteTransactionValidityDate: null,
        garantieFinanciereValidityDate: null,
        rcProfessionnelleValidityDate: null,
        garantieFinanciereFile: [],
        rcProfessionnelleFile: [],
        configDate: {
          altFormat: 'j/m/Y',
          altInput: true,
          dateFormat: 'd/m/Y'
        },
        currentYear: null,
        startDateOpened: false,
        startDateClosed: false,
        geoAddress: {},
        address: {},
        inlineAddress: null,
        invitUser: true,
        years: [2017, 2018, 2019, 2020, 2021, 2022],
        goals: [],
        managers: [],
        manager: null,
        panel: 'INFOS',
        route: this.$route,
        admins: [],
        referent: null
      }
    },
    mixins: [DefaultValues],
    props: {
      source: {
        type: Object,
        required: false
      },
      profiles: {
        type: Array,
        required: true
      },
      loading: {
        type: Boolean
      }
    },
    watch: {
      'u.company' (v) {
        this.manager = null
        if (v && v.pk) {
          this.getManagers(null, v)
        }
      }
    },
    computed: {
      ...mapState({
        currentUser: 'currentUser',
        companiesList: 'companies'
      }),
      ...mapGetters(['currentUserProfil', 'isAdmin', 'isExternal', 'isManager', 'isSectorManager', 'isLog', 'currentUserPk', 'canDisplayRemuneration']),
      isNew () {
        return isNil(this.user.pk)
      },
      profilHelperId () {
        if (!this.u.profil) {
          return null
        }
        let profil = this.profils.find(x => {
          return x.pk === this.u.profil
        })
        let IDS = {
          'admin': '4D3xFh8UxaQkq2oE64aIKA',
          'manager': 'uVBdwfzLc4OEgYmsEmkIS',
          'seller': '2BsdRNw5dOUSUi0ikSkGMu',
          'manager_ext': '2lmMG0n6JSWEeEG48Iys4i',
          'seller_ext': '82X9fxlpe0weccscQuk24',
          'operator': '6mIPD6QYykYcQ6QQ2k6y2c',
          'editor': '4V7aikZYjCciioKYUueo44'
        }
        return IDS[profil.type]
      },
      availableProfils () {
        let list = []
        if (!this.profilOrderList || !this.profilOrderList.length) return
        this.profilOrderList.forEach(x => {
          if (this.isAdmin) {
            list.push(x)
          } else if (this.isSectorManager && (x.type === 'seller_ext' || x.type === 'manager_ext')) {
            list.push(x)
          } else if (this.isManager && !this.isExternal && (x.type === 'seller')) {
            list.push(x)
          } else if (this.isManager && this.isExternal && (x.type === 'seller_ext')) {
            list.push(x)
          }
        })
        return list
      },
      u () {
        return this.user
      },
      canSubmit () {
        return this.emailAvailable // && (this.userIsExternal ? this.u.company : true)
      },
      userIsExternal () {
        if (!this.u.profil) {
          return false
        }
        if (!this.profilOrderList || this.profilOrderList.length === 0) {
          return false
        }
        let profilPk = this.u.profil.pk || this.u.profil
        let profil = find(this.profilOrderList, x => {
          return x.pk === profilPk
        })
        if (profil) {
          return profil.is_external
        }
        return false
      },
      currentGoal () {
        return this.goals.find(x => {
          return parseInt(x.year) === parseInt(this.currentYear)
        })
      },
      showSellerSettings () {
        let okProfils = ['seller', 'manager', 'seller_ext', 'manager_ext']
        return this.u.profil_type && okProfils.includes(this.u.profil_type) && (this.isAdmin || this.isManager || this.isSectorManager)
      },
      showGoalsForm () {
        let okProfils = ['seller', 'manager']
        return this.u.profil_type && okProfils.includes(this.u.profil_type) && (this.isAdmin || this.isManager)
      },
      showManagerForm () {
        let okProfils = ['seller', 'seller_ext']
        return this.u.profil_type && okProfils.includes(this.u.profil_type) && this.isNew
      },
      displaySwitchCanDisplayRem () {
        return (this.isAdmin || this.isSectorManager) && (this.u.pk !== this.currentUserPk || this.isNew) &&
               this.u.profil_type && !['editor', 'operator', 'admin'].includes(this.u.profil_type)
      },
      displaySwitchDisplayMyRem () {
        return !this.isNew && this.u.pk === this.currentUserPk && this.canDisplayRemuneration
      }
    },
    methods: {
      updateProfilType (value) {
        this.manager = null
        this.user.company = null
        if (this.u.profil) {
          let profil = this.profilsData.find(x => {
            return x.pk === this.u.profil
          })
          if (profil.type === 'seller') this.getManagers(null, null, profil.type)
          this.$set(this.user, 'profil_type', profil.type)
        }
      },
      sellerName (seller) {
        if (seller && seller.pk && seller.first_name) {
          let name = seller.first_name + ' ' + seller.last_name + ' (' + seller.email + ')'
          return name
        }
        return null
      },
      setCurrentYear (year) {
        this.currentYear = parseInt(year)
      },
      updateHelperText () {
        this.profilHelperText = null
        if (this.u.profil && this.profilHelperId && this.$contentful) {
          this.$contentful.getEntry(this.profilHelperId)
            .then(entry => {
              let converter = new showdown.Converter()
              let text = entry.fields.text
              this.profilHelperText = converter.makeHtml(text)
            })
        }
      },
      submit (redirect = true) {
        if (!isEmpty(this.rcProfessionnelleFile)) this.user.rc_professionnelle_file = this.rcProfessionnelleFile[0]
        else this.user.rc_professionnelle_file = null

        if (!isEmpty(this.carteTransactionFile)) this.user.carte_de_transaction_file = this.carteTransactionFile[0]
        else this.user.carte_de_transaction_file = null

        if (!isEmpty(this.garantieFinanciereFile)) this.user.garantie_financiere_file = this.garantieFinanciereFile[0]
        else this.user.garantie_financiere_file = null

        if (this.carteTransactionValidityDate && this.carteTransactionValidityDate !== '') {
          this.user.carte_de_transaction_validity_date = this.carteTransactionValidityDate
        } else {
          this.user.carte_de_transaction_validity_date = null
        }
        if (this.garantieFinanciereValidityDate && this.garantieFinanciereValidityDate !== '') {
          this.user.garantie_financiere_validity_date = this.garantieFinanciereValidityDate
        } else {
          this.user.garantie_financiere_validity_date = null
        }
        if (this.rcProfessionnelleValidityDate && this.rcProfessionnelleValidityDate !== '') {
          this.user.rc_professionnelle_validity_date = this.rcProfessionnelleValidityDate
        } else {
          this.user.rc_professionnelle_validity_date = null
        }
        if (this.manager) {
          this.user.manager = this.manager.pk
        }
        if (this.referent && this.referent.pk) {
          this.user.referent = this.referent.pk
        } else if (this.referent) {
          this.user.referent = this.referent
        } else this.user.referent = null

        if (this.address.city && this.address.zip_code) {
          this.user.address = Object.assign({}, this.address)
        } else {
          delete this.user.address
        }
        if (this.isNew) {
          if (this.isManager && this.isExternal) {
            this.user.profil = this.availableProfils.find(x => x.type === 'seller_ext')
          } else if (this.isManager) {
            this.user.profil = this.availableProfils.find(x => x.type === 'seller')
          }
        }
        if (this.user.max_options_by_client === '') this.user.max_options_by_client = 0
        if (this.user.max_options === '') this.user.max_options = 0
        if (this.user.remuneration === '') this.user.remuneration = null
        console.log(this.user.max_options)
        this.validate((valid) => {
          if (valid) {
            if (isEmpty(this.user.picture)) {
              this.user.picture = null
            }
            let goals = this.goals.slice()
            goals = goals.filter(x => {
              return parseFloat(x.goal) > 0
            })
            goals = orderBy(goals, 'year')
            this.user.goals = goals
            this.$emit('submit', this.user, redirect, this.invitUser)
          } else {
            this.$notify({
              type: 'is-danger',
              text: 'Erreur Le formulaire est invalide.'
            })
          }
        })
      },
      isEmpty (value) {
        return isEmpty(value)
      },
      getCompanies (query, init = null) {
        this.$api.companyService.get({name: query}).then(r => {
          this.companies = r.data.items
          if (init) {
            let company = this.companies.find(x => x.pk === this.$route.query.company)
            if (company) this.user.company = company
          }
        })
      },
      getManagers (query, company, profil) {
        let profilsPk = []
        if (!profil && this.u.profil_type) profil = this.u.profil_type
        if (this.profilOrderList && this.profilOrderList.length) {
          profilsPk = this.profilOrderList.filter(x => {
            if (profil === 'seller') {
              return x.is_manager && !x.is_external
            } else if (profil === 'seller_ext') {
              return x.is_manager && x.is_external
            } else {
              return x.is_manager
            }
          }).map(x => x.pk)
        }
        let params = {
          last_name: query,
          profil: profilsPk
        }
        if ((company && company.pk) || (this.u.company || (this.u.company && this.u.company.pk))) {
          params['company'] = company.pk || this.u.company.pk
        }
        this.$api.userService.get(params).then(r => {
          this.managers = r.data.items
        })
      },
      getAdmins (query) {
        let profilsPk = []
        if (this.profilOrderList && this.profilOrderList.length) {
          profilsPk = this.profilOrderList.filter(x => x.is_admin).map(x => x.pk)
        }
        let params = {
          last_name: query,
          profil: profilsPk
        }
        this.$api.userService.get(params).then(r => {
          this.admins = r.data.items
        })
      },
      validate (cb) {
        this.$validator.validateAll().then((result) => {
          cb(result)
        })
      },
      updateMail (val) {
        let previousVal = this.u.email
        this.u.email = val
        if (this.u.email !== previousVal && val.length >= 2) {
          this.$api.userService.get({email: val}).then(r => {
            if ((r.data.items.length === 1 && r.data.items[0].pk === this.u.pk) || (r.data.items.length === 1 && r.data.items[0].email !== val) || r.data.items.length === 0) {
              this.emailAvailable = true
            } else {
              this.emailAvailable = false
            }
          })
        }
      },
      uploadPictures (e) {
        this.u.picture = e[0]
        this.pictures = e
        // this.submit(false)
        // this.$emit('submit', this.user)
      },
      uploadcarteTransactionFile (e) {
        this.carteTransactionFile = e
      },
      uploadgarantieFinanciereFile (e) {
        this.garantieFinanciereFile = e
      },
      uploadrcProfessionnelleFile (e) {
        this.rcProfessionnelleFile = e
      },
      deleteFile (value1, value2) {
        this.$set(this, value1, [])
        this.$set(this.user, value2, null)
      },
      updateAddress ({address, location}) {
        this.$set(this, 'address', address)
      },
      async newUserFromTeam () {
        let externalMode = false
        if (this.$route.query && this.$route.query.manager) {
          if (this.$route.query.company) {
            externalMode = true
          }
          this.user.profil_type = externalMode ? 'seller_ext' : 'seller'
          if (this.profilOrderList && this.profilOrderList.length) {
            this.user.profil = this.profilOrderList.find(x => x.type === this.user.profil_type).pk
          }
          if (externalMode) {
            const company = await this.$api.companyService.getOne(this.$route.query.company)
            this.user.company = company.data
          }
          const manager = await this.$api.userService.getOne(this.$route.query.manager)
          this.user.manager = manager.data
          this.manager = manager.data
        }
      },
      getReferent (id) {
        this.$api.userService.getOne(id).then(r => {
          this.referent = r.data
        })
      }
    },
    created () {
      this.currentYear = moment().format('YYYY')
      this.companies = this.companiesList.slice()
      this.getCompanies(null, true)
      if (this.source) {
        this.user = Object.assign({}, this.source)
        this.user.profil = this.source.profil.pk
        this.address = Object.assign({}, this.source.address)
        this.completeAddress = true
        if (this.user.manager) {
          this.$api.userService.getOne(this.user.manager).then(r => {
            this.manager = r.data
          })
        }
        if (this.user.referent) {
          this.getReferent(this.user.referent)
        }
        let goals = []
        this.years.forEach(year => {
          let goal = this.user.goals.find(x => parseInt(x.year) === parseInt(year))
          if (goal) goals.push(goal)
          else goals.push({year: year, goal: 0})
        })
        this.goals = goals
      } else {
        this.getManagers()
        this.user = Object.assign({}, emptyUser)
        this.goals = []
        this.newUserFromTeam()
        if ('referent' in this.$route.query) {
          this.getReferent(this.$route.query.referent)
        }
      }
      if (this.isAdmin && !this.user.is_admin) this.getAdmins()

      if (this.isAdmin && this.$route.query && this.$route.query.company) {
        let profil = this.profilsData.find(x => x.type === 'seller_ext')
        if (profil && profil.pk) this.user.profil = profil.pk
        this.user.company = this.$route.query.company
      }

      if (isEmpty(this.user.picture)) this.pictures = []
      else this.pictures.push(this.user.picture)

      let fileList = [
        {file_value: 'rc_professionnelle_file', file: 'rcProfessionnelleFile', date_value: 'rc_professionnelle_validity_date', date: 'rcProfessionnelleValidityDate'},
        {file_value: 'carte_de_transaction_file', file: 'carteTransactionFile', date_value: 'carte_de_transaction_validity_date', date: 'carteTransactionValidityDate'},
        {file_value: 'garantie_financiere_file', file: 'garantieFinanciereFile', date_value: 'garantie_financiere_validity_date', date: 'garantieFinanciereValidityDate'}
      ]
      fileList.forEach(el => {
        if (!this.user[el.file_value] || this.user[el.file_value].path === null) this[el.file] = []
        else {
          this[el.file].push(this.user[el.file_value])
          this[el.date] = moment(this.user[el.date_value]).toDate()
        }
      })
      if (this.$route.params.panel) {
        this.panel = this.$route.params.panel
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/users/UserForm.vue